import { useCallback, useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { videoSamplesGetByCategoryIds } from 'api/endpoints/video-sample';
import Button from 'components/Button';
import { ENUM_TYPE_REPORT_STATUS, ENUM_TYPE_VIDEO, ENUM_TYPE_VIDEO_CATEGORY } from 'constants/enum';
import { CATEGORY_VIDEOS_ASE } from 'constants/index';
import useVideoCategory from 'hooks/useVideoCategory';
import { convertToQueryString, handleError } from 'utils/helper';

import RecentExerciseVideoSelectionFileSample from './RecentExerciseVideoSelectionFileSample';

const RecentExerciseVideoSelectionASE = ({
  isRecently,
  isReportRegistration = false,
  setShowPopupAddExerciseVideo,
  setTypeVideo,
  selectedVideoASE,
  handleRemoveVideo,
  currentStatus,
}) => {
  const { t } = useTranslation();

  const { getVideoCategory } = useVideoCategory();

  const [categoriesAssessment, setCategoriesAssessment] = useState([]);

  const isCallingApi = useRef(false);

  const _getCategoriesAssessment = async (_categoriesAssessment) => {
    if (_categoriesAssessment.length > 0) {
      const response = await getVideoCategory(ENUM_TYPE_VIDEO_CATEGORY.ASE);
      if (response) {
        const _categoriesAssessmentResult = _categoriesAssessment.map((item) => {
          return {
            fileSample: item,
            category: response.find((category) => category.id === item.id),
          };
        });
        setCategoriesAssessment(_categoriesAssessmentResult);
      }
    }
  };

  const _getVideoSamples = useCallback(async () => {
    if (selectedVideoASE.length > 0) {
      if (!isCallingApi.current) {
        try {
          isCallingApi.current = true;
          const queryString = convertToQueryString({ ids: selectedVideoASE });
          const response = await videoSamplesGetByCategoryIds(queryString);
          if (response && response.length > 0) {
            await _getCategoriesAssessment(response);
          }
        } catch (error) {
          handleError(error);
        } finally {
          isCallingApi.current = false;
        }
      }
    } else {
      setCategoriesAssessment([]);
    }
  }, [selectedVideoASE]);

  useEffect(() => {
    _getVideoSamples();
  }, [_getVideoSamples]);

  return (
    <>
      <div className="flex justify-between items-center mb-6 px-2 h-10">
        <p className="font-bold text-xl">
          {isRecently
            ? t('LATEST_EVALUATION_VIDEO_RECENTLY')
            : isReportRegistration
              ? t('LATEST_EVALUATION_VIDEO_REPORT_REGISTRATION')
              : t('LATEST_EVALUATION_VIDEO')}
        </p>
        {isReportRegistration && currentStatus === ENUM_TYPE_REPORT_STATUS.PROCESSING && (
          <Button
            type="button"
            color="primary-outline"
            text="運動の動画を追加"
            className="!rounded-full space-x-4 px-5"
            icon={<img src={require('assets/resources/PlusPrimary.svg').default} alt="plus icon" width={18} height={18} />}
            onClick={() => {
              setShowPopupAddExerciseVideo(true);
              setTypeVideo?.(ENUM_TYPE_VIDEO.ASE);
            }}
          />
        )}
      </div>
      <div className="mt-4 overflow-auto h-[calc(100%-64px)] px-2">
        <div className="flex flex-col space-y-6">
          {categoriesAssessment.map((item, index) => (
            <RecentExerciseVideoSelectionFileSample
              key={`video-category-assessment-${index}`}
              dataCategory={item.category || null}
              dataVideoSample={item.fileSample || null}
              handleRemoveVideo={handleRemoveVideo}
              isReportRegistration={isReportRegistration}
              categoryVideo={CATEGORY_VIDEOS_ASE}
              typeVideo={ENUM_TYPE_VIDEO.ASE}
              currentStatus={currentStatus}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default RecentExerciseVideoSelectionASE;
